import React, { useState, useEffect } from 'react'
import Select from "../Common/inputs/SelectDropdown";
import Input from "../Common/inputs/Input";
import { ExclusionPeriod, GamblingLimits, SelfExclusionPeriod, selfExclusionReasons, timeLimits } from "../Common/PrimaryplayerTab/ComTab";
import { updateuserLimit, setPersistedFormData } from "./GamblingLimitsSlice"
import { connect, useDispatch } from 'react-redux';
import { getPlayer } from '../primaryplayer/PrimaryPlayerSlice';
import { getDateFormate, getTimeFormat, getTimeinMinutes, amountUnitConversion, amountDecimalRegex, amountInputValue } from '../../sharedfiles/helper';
import { Gambling } from '../../sharedfiles/tooltipMsgs';
import { Button } from '../../ui/button';
import { COMMON_CONSTANTS } from '../../sharedfiles/Constants';
import { getBrandCurrenciesList } from '../createbonusnew/createbonusnewslice';
import { FALLBACK_CURRENCIES } from '../createbonusv2/templates';

const ResponsibleGambling = (props) => {
  // Restore the form only for the same player it was saved for
  const persistedFormData = props.persistedFormData?.userId === localStorage.getItem("userId") ? props.persistedFormData : {}
  const [GambleLimits, setGambleLimits] = useState(() => persistedFormData.GambleLimits ?? "")
  const [Timelimit, setTimeLimit] = useState(() => persistedFormData.Timelimit ?? "")
  const [selfTimeLimit, setSelfTimeLimit] = useState(() => persistedFormData.selfTimeLimit ?? "")
  const [Limits, setLimits] = useState(() => persistedFormData.Limits ?? "")
  const [LimitErr, setLimitErr] = useState(false)
  const [selfLimitErr, setSelfLimitErr] = useState(false)
  const [timeLimitErr, setTimeLimitErr] = useState(false)
  const [GambleLimitErr, setGambleLimitErr] = useState(false)
  const [ExclusionTime, SetExclusionTime] = useState(() => persistedFormData.ExclusionTime ?? "")
  const [ExclusionErr, setExclusionErr] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [Timedisabled, setTimeDisabled] = useState(false)
  const [Exdisable, setExDisable] = useState(false)
  const [resetDisable, setResetDisable] = useState(false)
  const [resetExDisable, setResetExDisable] = useState(false)
  const dispatch = useDispatch();
  // Same currency source as the Create Bonus page
  const currencyOptions = props.brandCurrenciesList?.length > 0 ? props.brandCurrenciesList : FALLBACK_CURRENCIES
  const [limitCurrency, setLimitCurrency] = useState(() => persistedFormData.limitCurrency ?? "")

  const limitFields = {
    DepositLimits: { Daily: "dailyDepositLimit", Weekly: "weeklyDepositLimit", Monthly: "monthlyDepositLimit" },
    WithdrawalLimits: { Daily: "dailyWithdrawalLimit", Weekly: "weeklyWithdrawalLimit", Monthly: "monthlyWithdrawalLimit" },
    BettingLimits: { Daily: "dailyStakeLimit", Weekly: "weeklyStakeLimit", Monthly: "monthlyStakeLimit" },
  }

  // Stored limits belong to userLimit.currencyCode (falls back to the player's currency when null).
  // Empty until a currency is selected; the amount when it matches, otherwise 0.
  const storedLimitAmount = (amount, currency) => {
    if (!currency) return ""
    const storedCurrency = props.playerData?.userLimit?.currencyCode || props.playerData?.userOtherInfo?.currencyCode
    if (!storedCurrency || storedCurrency.toUpperCase() !== currency.toUpperCase()) return 0
    return amountInputValue(amount, currency)
  }

  const [selfExcludeData, setSelfExcludeData] = useState(() => persistedFormData.selfExcludeData ?? {
    exclusionPeriodNumber: "",
    selfExclusionReason: null,
    otherReason: "",
  })
  const [selfExcludeDataErr, setSelfExcludeDataErr] = useState({
    exclusionPeriodNumberErr: false,
    selfExclusionReasonErr: false,
    otherReasonErr: false,
  })
  const [exclusionPeriodNumberAuto, setExclusionPeriodNumberAuto] = useState([]);

  useEffect(() => {
    let max = 0;
    if (ExclusionTime === "WEEK") max = 26;
    if (ExclusionTime === "MONTH") max = 12;
    if (ExclusionTime === "YEAR") max = 10;

    const values = Array.from({ length: max }, (_, i) => ({
      id: i + 1,
      label: `${ExclusionTime} ${i + 1}`,
      value: `${ExclusionTime}${i + 1}`
    }));

    setExclusionPeriodNumberAuto(values);
  }, [ExclusionTime]);


  const handleChange = (e) => {
    const { value } = e.target
    if (value === "WithdrawalLimits" || value === "BettingLimits" || value === "DepositLimits") {
      setTimeLimit("")
      setLimits("")
    }

    setGambleLimits(value)
    setSelfLimitErr(false)
    setTimeLimitErr(false)
    setLimitErr(false)
    setExclusionErr(false)
    if (value === "") {
      setGambleLimitErr(true)
    } else {
      setGambleLimitErr(false)
    }
  }

  const selectHandler = (e) => {
    const { name, value } = e.target
    if (name === "selfTimeLimit") {
      setSelfTimeLimit(value)
    }
    if (name === "exclusionTime") {
      SetExclusionTime(value)
    }
    if (value === "") {
      setSelfLimitErr(true)
      setTimeLimitErr(true)
    }
    if (value !== "") {
      setSelfLimitErr(false)
      setTimeLimitErr(false)
      setExclusionErr(false)
    }
    if (name === "Timelimit") {
      setTimeLimit(value)
    }

    if (GambleLimits === "DepositLimits" && value === "Daily") {
      const formatValue = storedLimitAmount(props.playerData.userLimit.dailyDepositLimit, limitCurrency)
      setLimits(formatValue)
      setLimitErr(false)
      setDisabled(false)
    }
    if (GambleLimits === "DepositLimits" && value === "Weekly") {
      const formatValue = storedLimitAmount(props.playerData.userLimit.weeklyDepositLimit, limitCurrency)
      setLimits(formatValue)
      setLimitErr(false)
      setDisabled(false)
    }
    if (GambleLimits === "DepositLimits" && value === "Monthly") {
      const formatValue = storedLimitAmount(props.playerData.userLimit.monthlyDepositLimit, limitCurrency)
      setLimits(formatValue)
      setLimitErr(false)
      setDisabled(false)
    }

    if (GambleLimits === "WithdrawalLimits" && value === "Daily") {
      const formatValue = storedLimitAmount(props.playerData.userLimit.dailyWithdrawalLimit, limitCurrency)
      setLimits(formatValue)
      setLimitErr(false)
      setDisabled(false)
    }
    if (GambleLimits === "WithdrawalLimits" && value === "Weekly") {
      const formatValue = storedLimitAmount(props.playerData.userLimit.weeklyWithdrawalLimit, limitCurrency)
      setLimits(formatValue)
      setLimitErr(false)
      setDisabled(false)
    }
    if (GambleLimits === "WithdrawalLimits" && value === "Monthly") {
      const formatValue = storedLimitAmount(props.playerData.userLimit.monthlyWithdrawalLimit, limitCurrency)
      setLimits(formatValue)
      setLimitErr(false)
      setDisabled(false)
    }

    if (GambleLimits === "BettingLimits" && value === "Daily") {
      const formatValue = storedLimitAmount(props.playerData.userLimit.dailyStakeLimit, limitCurrency)
      setLimits(formatValue)
      setLimitErr(false)
      setDisabled(false)
    }
    if (GambleLimits === "BettingLimits" && value === "Weekly") {
      const formatValue = storedLimitAmount(props.playerData.userLimit.weeklyStakeLimit, limitCurrency)
      setLimits(formatValue)
      setLimitErr(false)
      setDisabled(false)
    }
    if (GambleLimits === "BettingLimits" && value === "Monthly") {
      const formatValue = storedLimitAmount(props.playerData.userLimit.monthlyStakeLimit, limitCurrency)
      setLimits(formatValue)
      setLimitErr(false)
      setDisabled(false)
    }
  }

  // Amounts are currency-specific, so reload the stored limit for the newly selected currency
  const handleCurrencyChange = (e) => {
    const { value } = e.target
    if (value === limitCurrency) return
    setLimitCurrency(value)
    const field = limitFields[GambleLimits]?.[Timelimit]
    setLimits(field ? storedLimitAmount(props.playerData?.userLimit?.[field], value) : "")
    setLimitErr(false)
    setDisabled(false)
  }

  const inputHandler = (e) => {
    const { name, value } = e.target
    if (name === "Limits") {
      setLimits(value)
      setDisabled(false)
      setLimitErr(false)
    }
    // Empty / zero is validated on Save, so clearing the default 0 or typing "0.5" doesn't flag an error mid-edit
  }


  const onSubmit = (e) => {
    if (Timelimit === "") {
      setTimeLimitErr(true)
    }
    if (Limits === "") {
      setLimitErr("Please enter Proper Limits")
    } else if (Number(Limits) === 0) {
      setLimitErr("Value Must be greater than 0")
    }
    if (GambleLimits !== "" && Timelimit !== "" && Limits !== "" && Number(Limits) > 0) {

      if (GambleLimits === "DepositLimits" && Timelimit === "Daily") {
        let dailyDeposit = { dailyDepositLimit: amountUnitConversion(Limits, limitCurrency), ...(limitCurrency && { currencyCode: limitCurrency }) }
        dispatch(updateuserLimit(localStorage.getItem("userId"), dailyDeposit))
      }
      else if (GambleLimits === "DepositLimits" && Timelimit === "Weekly") {
        let WeeklyDeposit = { weeklyDepositLimit: amountUnitConversion(Limits, limitCurrency), ...(limitCurrency && { currencyCode: limitCurrency }) }
        dispatch(updateuserLimit(localStorage.getItem("userId"), WeeklyDeposit))
      }
      else if (GambleLimits === "DepositLimits" && Timelimit === "Monthly") {
        let MonthlyDeposit = { monthlyDepositLimit: amountUnitConversion(Limits, limitCurrency), ...(limitCurrency && { currencyCode: limitCurrency }) }
        dispatch(updateuserLimit(localStorage.getItem("userId"), MonthlyDeposit))
      }

      if (GambleLimits === "WithdrawalLimits" && Timelimit === "Daily") {
        let dailyWithdraw = { dailyWithdrawalLimit: amountUnitConversion(Limits, limitCurrency), ...(limitCurrency && { currencyCode: limitCurrency }) }
        dispatch(updateuserLimit(localStorage.getItem("userId"), dailyWithdraw))
      }
      else if (GambleLimits === "WithdrawalLimits" && Timelimit === "Weekly") {
        let WeeklyWithdraw = { weeklyWithdrawalLimit: amountUnitConversion(Limits, limitCurrency), ...(limitCurrency && { currencyCode: limitCurrency }) }
        dispatch(updateuserLimit(localStorage.getItem("userId"), WeeklyWithdraw))
      }
      else if (GambleLimits === "WithdrawalLimits" && Timelimit === "Monthly") {
        let MonthlyWithdraw = { monthlyWithdrawalLimit: amountUnitConversion(Limits, limitCurrency), ...(limitCurrency && { currencyCode: limitCurrency }) }
        dispatch(updateuserLimit(localStorage.getItem("userId"), MonthlyWithdraw))
      }

      if (GambleLimits === "BettingLimits" && Timelimit === "Daily") {
        let dailyBets = { dailyStakeLimit: amountUnitConversion(Limits, limitCurrency), ...(limitCurrency && { currencyCode: limitCurrency }) }
        dispatch(updateuserLimit(localStorage.getItem("userId"), dailyBets))
      }
      else if (GambleLimits === "BettingLimits" && Timelimit === "Weekly") {
        let WeeklyBets = { weeklyStakeLimit: amountUnitConversion(Limits, limitCurrency), ...(limitCurrency && { currencyCode: limitCurrency }) }
        dispatch(updateuserLimit(localStorage.getItem("userId"), WeeklyBets))
      }
      else if (GambleLimits === "BettingLimits" && Timelimit === "Monthly") {
        let MonthlyBets = { monthlyStakeLimit: amountUnitConversion(Limits, limitCurrency), ...(limitCurrency && { currencyCode: limitCurrency }) }
        dispatch(updateuserLimit(localStorage.getItem("userId"), MonthlyBets))
      }

      setDisabled(true)
      setTimeLimitErr(false)
      setLimitErr(false)
      setTimeout(() => {
        dispatch(getPlayer({ user_id: localStorage.getItem("userId") }))
      }, 500)
    }

    if (!selfExcludeData?.exclusionPeriodNumber) {
      setSelfExcludeDataErr({ ...selfExcludeDataErr, exclusionPeriodNumberErr: true })
    }
    if (!selfExcludeData?.selfExclusionReason) {
      setSelfExcludeDataErr({ ...selfExcludeDataErr, selfExclusionReasonErr: true })
    }
    if (!selfExcludeData?.otherReason) {
      setSelfExcludeDataErr({ ...selfExcludeDataErr, otherReasonErr: true })
    }
  }

  useEffect(() => {
    props.playerData?.userLimit?.selfExcludePeriod ? setExDisable(true) : setExDisable(false)
    props.playerData?.userLimit?.timeLimit ? setTimeDisabled(true) : setTimeDisabled(false)
    !props.playerData?.userLimit?.timeLimit ? setResetDisable(true) : setResetDisable(false)
    !props.playerData?.userLimit?.selfExcludePeriod ? setResetExDisable(true) : setResetExDisable(false)
    if (!props.brandCurrenciesList?.length) {
      dispatch(getBrandCurrenciesList());
    }
  }, [])

  const handleInputData = (e) => {
    const { name, value } = e.target;

    setSelfExcludeData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "selfExclusionReason" && value !== "Others") {
      setSelfExcludeData((prev) => ({
        ...prev,
        otherReason: ""
      }));
      setSelfExcludeDataErr((prev) => ({
        ...prev,
        otherReasonErr: false
      }));
    }

    if (name === "otherReason") {
      setSelfExcludeDataErr((prev) => ({
        ...prev,
        otherReasonErr: value.trim() === ""
      }));
    }
  };

  const onExSave = () => {
    const userId = localStorage.getItem("userId");

    if (ExclusionTime === "") {
      setExclusionErr(true);
      return;
    } else {
      setExclusionErr(false);
    }

    const payload = {};

    if (["WEEK", "MONTH", "YEAR"].includes(ExclusionTime)) {
      payload.selfExclusion = ExclusionTime;

      if (selfExcludeData.exclusionPeriodNumber) {
        payload.selfExclusionPeriod = selfExcludeData.exclusionPeriodNumber;
        setSelfExcludeDataErr((prev) => ({
          ...prev,
          exclusionPeriodNumberErr: false,
        }));
      } else {
        setSelfExcludeDataErr((prev) => ({
          ...prev,
          exclusionPeriodNumberErr: false,
        }));
      }
    }

    if (ExclusionTime === "PERMANENT") {
      payload.selfExclusion = "PERMANENT";
    }

    if (selfExcludeData.selfExclusionReason === "Others") {
      if (!selfExcludeData.otherReason?.trim()) {
        setSelfExcludeDataErr((prev) => ({
          ...prev,
          otherReasonErr: true,
          selfExclusionReasonErr: false,
        }));
        return;
      } else {
        setSelfExcludeDataErr((prev) => ({
          ...prev,
          otherReasonErr: false,
          selfExclusionReasonErr: false,
        }));
        payload.selfExclusionReason = selfExcludeData.otherReason.trim();
      }
    } else {
      payload.selfExclusionReason = selfExcludeData.selfExclusionReason || "";
      setSelfExcludeDataErr((prev) => ({
        ...prev,
        selfExclusionReasonErr: false,
      }));
    }

    dispatch(updateuserLimit(userId, payload));
    setExDisable(true);
    setResetExDisable(false);

    setTimeout(() => {
      dispatch(getPlayer({ user_id: userId }));
    }, 500);
  };

  const onTimeSave = () => {
    if (selfTimeLimit === "") {
      setSelfLimitErr(true)
    }
    if (selfTimeLimit !== "") {
      setSelfLimitErr(false)
    }

    if (GambleLimits !== "" && selfTimeLimit !== "") {
      if (GambleLimits === "TimeLimits" && selfTimeLimit === "15Mins") {
        let timeLimit = { timeLimit: 15 }
        dispatch(updateuserLimit(localStorage.getItem("userId"), timeLimit))
      }
      if (GambleLimits === "TimeLimits" && selfTimeLimit === "30Mins") {
        let timeLimit = { timeLimit: 30 }
        dispatch(updateuserLimit(localStorage.getItem("userId"), timeLimit))
      }
      if (GambleLimits === "TimeLimits" && selfTimeLimit === "1Hr") {
        let timeLimit = { timeLimit: getTimeinMinutes(1) }
        dispatch(updateuserLimit(localStorage.getItem("userId"), timeLimit))

      }
      if (GambleLimits === "TimeLimits" && selfTimeLimit === "2Hrs") {
        let timeLimit = { timeLimit: getTimeinMinutes(2) }
        dispatch(updateuserLimit(localStorage.getItem("userId"), timeLimit))

      }
      if (GambleLimits === "TimeLimits" && selfTimeLimit === "4Hrs") {
        let timeLimit = { timeLimit: getTimeinMinutes(4) }
        dispatch(updateuserLimit(localStorage.getItem("userId"), timeLimit))
      }
      if (GambleLimits === "TimeLimits" && selfTimeLimit === "8Hrs") {
        let timeLimit = { timeLimit: getTimeinMinutes(8) }
        dispatch(updateuserLimit(localStorage.getItem("userId"), timeLimit))
      }
      setTimeDisabled(true)
      setResetDisable(false)
      setTimeout(() => {
        dispatch(getPlayer({ user_id: localStorage.getItem("userId") }))
      }, 500)
    }
  }

  const onReset = () => {
    if (GambleLimits !== "" && Timelimit !== "") {
      if (GambleLimits === "DepositLimits" && Timelimit === "Daily") {
        let dailyDeposit = { dailyDepositLimit: 0 }
        dispatch(updateuserLimit(localStorage.getItem("userId"), dailyDeposit))
      }
      else if (GambleLimits === "DepositLimits" && Timelimit === "Weekly") {
        let WeeklyDeposit = { weeklyDepositLimit: 0 }
        dispatch(updateuserLimit(localStorage.getItem("userId"), WeeklyDeposit))
      }
      else if (GambleLimits === "DepositLimits" && Timelimit === "Monthly") {
        let MonthlyDeposit = { monthlyDepositLimit: 0 }
        dispatch(updateuserLimit(localStorage.getItem("userId"), MonthlyDeposit))
      }

      if (GambleLimits === "WithdrawalLimits" && Timelimit === "Daily") {
        let dailyWithdraw = { dailyWithdrawalLimit: 0 }
        dispatch(updateuserLimit(localStorage.getItem("userId"), dailyWithdraw))
      }
      else if (GambleLimits === "WithdrawalLimits" && Timelimit === "Weekly") {
        let WeeklyWithdraw = { weeklyWithdrawalLimit: 0 }
        dispatch(updateuserLimit(localStorage.getItem("userId"), WeeklyWithdraw))
      }
      else if (GambleLimits === "WithdrawalLimits" && Timelimit === "Monthly") {
        let MonthlyWithdraw = { monthlyWithdrawalLimit: 0 }
        dispatch(updateuserLimit(localStorage.getItem("userId"), MonthlyWithdraw))
      }

      if (GambleLimits === "BettingLimits" && Timelimit === "Daily") {
        let dailyBets = { dailyStakeLimit: 0 }
        dispatch(updateuserLimit(localStorage.getItem("userId"), dailyBets))
      }
      else if (GambleLimits === "BettingLimits" && Timelimit === "Weekly") {
        let WeeklyBets = { weeklyStakeLimit: 0 }
        dispatch(updateuserLimit(localStorage.getItem("userId"), WeeklyBets))
      }
      else if (GambleLimits === "BettingLimits" && Timelimit === "Monthly") {
        let MonthlyBets = { monthlyStakeLimit: 0 }
        dispatch(updateuserLimit(localStorage.getItem("userId"), MonthlyBets))
      }
      setDisabled(false)
      setTimeLimitErr(false)
      setTimeout(() => {
        dispatch(getPlayer({ user_id: localStorage.getItem("userId") }))
      }, 500)
    }
    setLimits("")
    setTimeLimit("")
    setLimitErr("")
    setTimeLimitErr(false)
  }

  const reset = (e) => {
    if (ExclusionTime === "PERMANENT") return;
    if (GambleLimits !== "" && ExclusionTime !== "") {
      if (GambleLimits === "SelfExclusionPeriod" && ExclusionTime === "WEEK") {
        let weekly = { selfExclusion: "NULL" }
        dispatch(updateuserLimit(localStorage.getItem("userId"), weekly))
      }
      if (GambleLimits === "SelfExclusionPeriod" && ExclusionTime === "MONTH") {
        let monthly = { selfExclusion: "NULL" }
        dispatch(updateuserLimit(localStorage.getItem("userId"), monthly))
      }
      if (GambleLimits === "SelfExclusionPeriod" && ExclusionTime === "YEAR") {
        let yearly = { selfExclusion: "NULL" }
        dispatch(updateuserLimit(localStorage.getItem("userId"), yearly))
      }
      setTimeout(() => {
        dispatch(getPlayer({ user_id: localStorage.getItem("userId") }))
      }, 500)
    }
    if (GambleLimits === "SelfExclusionPeriod" && ExclusionTime === "") {
      let reset = { selfExclusion: "NULL" }
      dispatch(updateuserLimit(localStorage.getItem("userId"), reset))
      setResetExDisable(true)
      setTimeout(() => {
        dispatch(getPlayer({ user_id: localStorage.getItem("userId") }))
      }, 500)
    }
    setSelfExcludeData({
      exclusionPeriodNumber: "",
      selfExclusionReason: "",
      otherReason: "",
    })
    setSelfLimitErr("")
    SetExclusionTime("")
    setDisabled(false)
    setExDisable(false)
    setResetExDisable(true)
  }


  const onTymReset = () => {
    if (GambleLimits !== "" && selfTimeLimit !== "") {
      if (GambleLimits === "TimeLimits" && selfTimeLimit === "15Mins") {
        let timeLimit = { timeLimit: 0 }
        dispatch(updateuserLimit(localStorage.getItem("userId"), timeLimit))
      }
      if (GambleLimits === "TimeLimits" && selfTimeLimit === "30Mins") {
        let timeLimit = { timeLimit: 0 }
        dispatch(updateuserLimit(localStorage.getItem("userId"), timeLimit))
      }
      if (GambleLimits === "TimeLimits" && selfTimeLimit === "1Hr") {
        let timeLimit = { timeLimit: 0 }
        dispatch(updateuserLimit(localStorage.getItem("userId"), timeLimit))
      }
      if (GambleLimits === "TimeLimits" && selfTimeLimit === "2Hrs") {
        let timeLimit = { timeLimit: 0 }
        dispatch(updateuserLimit(localStorage.getItem("userId"), timeLimit))
      }
      if (GambleLimits === "TimeLimits" && selfTimeLimit === "4Hrs") {
        let timeLimit = { timeLimit: 0 }
        dispatch(updateuserLimit(localStorage.getItem("userId"), timeLimit))
      }
      if (GambleLimits === "TimeLimits" && selfTimeLimit === "8Hrs") {
        let timeLimit = { timeLimit: 0 }
        dispatch(updateuserLimit(localStorage.getItem("userId"), timeLimit))
      }
      setTimeout(() => {
        dispatch(getPlayer({ user_id: localStorage.getItem("userId") }))
      }, 500)
    }
    if (GambleLimits === "TimeLimits" && selfTimeLimit === "") {
      let reset = { timeLimit: 0 }
      dispatch(updateuserLimit(localStorage.getItem("userId"), reset))
      setResetDisable(true)
      setTimeout(() => {
        dispatch(getPlayer({ user_id: localStorage.getItem("userId") }))
      }, 500)
    }
    setSelfTimeLimit("")
    setTimeDisabled(false)
    setResetDisable(true)
  }

  // Mirrors the persistable form fields into redux on every change, so they
  // survive this page unmounting/remounting on tab switch.
  useEffect(() => {
    dispatch(setPersistedFormData({ userId: localStorage.getItem("userId"), GambleLimits, Timelimit, selfTimeLimit, Limits, ExclusionTime, limitCurrency, selfExcludeData }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [GambleLimits, Timelimit, selfTimeLimit, Limits, ExclusionTime, limitCurrency, selfExcludeData]);

  return (
      <div className='flex flex-col gap-4'>
        <div>
          <h2 className='text-lg font-semibold text-foreground'>Responsible Gambling Settings</h2>
          <p className='text-sm text-muted-foreground mt-1'>Manage gambling limits and self-exclusion periods</p>
        </div>

        <div className='space-y-6'>
          {/* Main Selection Grid */}
          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4'>
            <div className='space-y-2'>
              <Select
                title={"Gambling Limits"}
                name={"GambleLimits"}
                ids={"GamblingLimits"}
                value={GambleLimits}
                setValue={(val) => handleChange(val)}
                options={GamblingLimits}
                errorMsg={GambleLimitErr && "Please select your Gambling Limits"}
                info={Gambling.limits}
              />
            </div>

            {GambleLimits === "DepositLimits" || GambleLimits === "WithdrawalLimits" || GambleLimits === "BettingLimits" ? (
              <div className='space-y-2'>
                <Select
                  title={"Time Limits"}
                  name={"Timelimit"}
                  ids={"Timelimit"}
                  value={Timelimit}
                  setValue={(val) => selectHandler(val)}
                  options={SelfExclusionPeriod}
                  errorMsg={timeLimitErr && "Please select your Time Limits"}
                  info={Gambling.Time_Limits}
                />
              </div>
            ) : GambleLimits === "SelfExclusionPeriod" ? (
              <div className='space-y-2'>
                <Select
                  title={"Exclusion Period"}
                  name={"exclusionTime"}
                  ids={"exclusionTime"}
                  value={ExclusionTime}
                  setValue={(val) => selectHandler(val)}
                  options={ExclusionPeriod}
                  errorMsg={ExclusionErr && "Please select your Exclusion Period"}
                  info={Gambling.Exclusion_Period}
                />
              </div>
            ) : GambleLimits === "TimeLimits" ? (
              <div className='space-y-2'>
                <Select
                  title={"Time Period"}
                  name={"selfTimeLimit"}
                  ids={"selfTimeLimit"}
                  value={selfTimeLimit}
                  setValue={(val) => selectHandler(val)}
                  options={timeLimits}
                  errorMsg={selfLimitErr && "Please select your Time Limits"}
                  info={Gambling.Exclusion_Period}
                />
              </div>
            ) : null}

            {GambleLimits === "DepositLimits" || GambleLimits === "WithdrawalLimits" || GambleLimits === "BettingLimits" ? (
              <div className='space-y-2'>
                <Select
                  title={"Currency"}
                  name={"limitCurrency"}
                  ids={"limitCurrency"}
                  value={limitCurrency}
                  setValue={(e) => handleCurrencyChange(e)}
                  options={[
                    { label: COMMON_CONSTANTS.ddlOpt_select, value: '' },
                    ...currencyOptions
                  ]}
                  info={"Select the currency for the limits"}
                />
              </div>
            ) : null}

            {GambleLimits === "DepositLimits" || GambleLimits === "WithdrawalLimits" || GambleLimits === "BettingLimits" ? (
              <div className='space-y-2'>
                <Input
                  title={"Limit Amount"}
                  placeholder={"Enter limit amount"}
                  name={"Limits"}
                  type={"text"}
                  ids={"Limits"}
                  value={Limits}
                  setValue={(e) => inputHandler(e)}
                  errorMsg={LimitErr}
                  info={Gambling.bet_Limits}
                  show={true}
                  regex={amountDecimalRegex(limitCurrency)}
                />
              </div>
            ) : null}

            {ExclusionTime !== "" && ExclusionTime !== "PERMANENT" ? (
              <div className='space-y-2'>
                <Select
                  title={"Exclusion Period Number"}
                  name={"exclusionPeriodNumber"}
                  ids={"exclusionPeriodNumber"}
                  value={selfExcludeData?.exclusionPeriodNumber}
                  setValue={(val) => handleInputData(val)}
                  options={exclusionPeriodNumberAuto}
                  errorMsg={selfExcludeDataErr?.exclusionPeriodNumberErr && "Please select period number"}
                  info={Gambling.Exclusion_Period_Number}
                />
              </div>
            ) : null}

            {ExclusionTime !== "" ? (
              <div className='space-y-2'>
                <Select
                  title={"Exclusion Reason"}
                  name={"selfExclusionReason"}
                  ids={"selfExclusionReason"}
                  value={selfExcludeData?.selfExclusionReason}
                  setValue={(val) => handleInputData(val)}
                  options={selfExclusionReasons}
                  errorMsg={selfExcludeDataErr?.selfExclusionReasonErr && "Please select a reason"}
                  info={Gambling.Self_Exclusion_reason}
                />
              </div>
            ) : null}

            {selfExcludeData?.selfExclusionReason === "Others" ? (
              <div className='space-y-2'>
                <Input
                  title={"Other Reason"}
                  name={"otherReason"}
                  type={"text"}
                  ids={"otherReason"}
                  value={selfExcludeData?.otherReason}
                  setValue={(e) => handleInputData(e)}
                  errorMsg={selfExcludeDataErr?.otherReasonErr && "Please enter reason"}
                  info="Enter reason (max 30 characters)"
                  show={true}
                  maxLen={30}
                  placeholder={"Other reason (max 30 characters)"}
                />
              </div>
            ) : null}
          </div>

          {/* Status Information */}
          {GambleLimits === "SelfExclusionPeriod" && props.playerData?.userLimit?.selfExcludePeriod && (
            <div className='p-4 bg-blue-50 dark:bg-blue-950 border border-blue-200 dark:border-blue-800 rounded-lg'>
              <p className='text-sm font-medium text-blue-900 dark:text-blue-100'>
                Self-Exclusion period will complete by {getDateFormate(props.playerData.userLimit.selfExcludePeriod)}
              </p>
            </div>
          )}

          {GambleLimits === "TimeLimits" && props.playerData?.userLimit?.timeLimit && props.playerData.userLimit.timeLimit > 0 && (
            <div className='p-4 bg-blue-50 dark:bg-blue-950 border border-blue-200 dark:border-blue-800 rounded-lg'>
              <p className='text-sm font-medium text-blue-900 dark:text-blue-100'>
                Time Limit will complete in {getTimeFormat(props.playerData.userLimit.timeLimit)}&nbsp;
                {props.playerData.userLimit.timeLimit >= 120 ? "Hours" : props.playerData.userLimit.timeLimit >= 60 ? "Hour" : "Minutes"}
              </p>
            </div>
          )}

          {/* Action Buttons */}
          {GambleLimits === "DepositLimits" || GambleLimits === "WithdrawalLimits" || GambleLimits === "BettingLimits" ? (
            <div className='flex gap-3 pt-4 border-t'>
              <Button
                variant="default"
                onClick={(e) => onSubmit(e)}
                disabled={disabled || props.viewOnlyuser}
                className='min-w-[120px]'
              >
                Save
              </Button>
              <Button
                variant="outline"
                onClick={(e) => onReset(e)}
                disabled={props.viewOnlyuser}
                className='min-w-[120px]'
              >
                Reset
              </Button>
            </div>
          ) : null}

          {GambleLimits === "SelfExclusionPeriod" ? (
            <div className='flex gap-3 pt-4 border-t'>
              <Button
                variant="default"
                onClick={onExSave}
                disabled={Exdisable || props.viewOnlyuser}
                className='min-w-[120px]'
              >
                Save
              </Button>
              <Button
                variant="outline"
                onClick={() => reset()}
                disabled={ExclusionTime === "PERMANENT" || props.viewOnlyuser || !ExclusionTime}
                className='min-w-[120px]'
              >
                Reset
              </Button>
            </div>
          ) : null}

          {GambleLimits === "TimeLimits" ? (
            <div className='flex gap-3 pt-4 border-t'>
              <Button
                variant="default"
                onClick={(e) => onTimeSave(e)}
                disabled={Timedisabled || props.viewOnlyuser}
                className='min-w-[120px]'
              >
                Save
              </Button>
              <Button
                variant="outline"
                onClick={() => onTymReset()}
                disabled={resetDisable || props.viewOnlyuser}
                className='min-w-[120px]'
              >
                Reset
              </Button>
            </div>
          ) : null}
        </div>
      </div>
  )
}
const mapStateToProps = (state) => {
  return {
    playerData: state.primaryplayer.playerData,
    viewOnlyuser: state.dashboard.viewOnlyuser,
    brandCurrenciesList: state.bonus.brandCurrenciesList,
    persistedFormData: state.responsiblegambling.persistedFormData,
  };
};

export default connect(mapStateToProps)(ResponsibleGambling)